var ko = require('knockout');

ko.bindingHandlers.dynamicHeight = {
  //Based on parent
  init: function(element, valueAccessor) {
    var el = $(element);
    var parentClass = ko.unwrap(valueAccessor());
    var parent = el.closest('.' + parentClass);
    el.height(parent.outerHeight());
  }
};
// Do callback when enterkey is pressed.
ko.bindingHandlers.enterkey = {
  init: function(element, valueAccessor, allBindings, viewModel) {
    var callback = valueAccessor();
    $(element).keypress(function(event) {
      var keyCode = event.which ? event.which : event.keyCode;
      if (keyCode === 13) {
        callback.call(viewModel);
        return false;
      }
      return true;
    });
  }
};
// Fade between transitions.
ko.bindingHandlers.fadeVisible = {
  init: function(element, valueAccessor) {
    var value = valueAccessor();
    $(element).toggle(ko.unwrap(value));
  },
  update: function(element, valueAccessor) {
    var value = valueAccessor();
    if (ko.unwrap(value)) {
      $(element)
        .delay(150)
        .fadeIn(150);
    } else {
      $(element).fadeOut(150);
    }
  }
};
// Get element in component init function.
ko.bindingHandlers.useElement = {
  init: function(element, valueAccessor, allBindingsAccessor, viewModel) {
    viewModel.init(element);
    ko.utils.domNodeDisposal.addDisposeCallback(element, function() {
      viewModel.element = null;
      delete viewModel.element;
    });
  }
};

// Will trigger afterMarkupRender function after markup above this handler is triggered.
ko.bindingHandlers.afterMarkupRender = {
  init: function(element, valueAccessor, allBinidingsAccessor, viewModel) {
    viewModel.afterMarkupRender(element);
    ko.utils.domNodeDisposal.addDisposeCallback(element, function() {
      viewModel.element = null;
      delete viewModel.element;
    });
  }
};

ko.bindingHandlers.toggleVar = {
  init: function(element, valueAccessor) {
    $(element).on('click.toggleVar', function() {
      var value = valueAccessor();
      value(!value());
    });
    ko.utils.domNodeDisposal.addDisposeCallback(element, function() {
      $(element).off('.toggleVar');
    });
  }
};

ko.bindingHandlers.numeric = {
  init: function(element) {
    $(element).on('keydown', function(event) {
      // Allow: backspace, delete, tab, escape, and enter
      if (
        event.keyCode == 46 ||
        event.keyCode == 8 ||
        event.keyCode == 9 ||
        event.keyCode == 27 ||
        event.keyCode == 13 ||
        // Allow: Ctrl+A
        (event.keyCode == 65 && event.ctrlKey === true) ||
        // Allow: . ,
        (event.keyCode == 188 ||
          event.keyCode == 190 ||
          event.keyCode == 110) ||
        // Allow: home, end, left, right
        (event.keyCode >= 35 && event.keyCode <= 39)
      ) {
        // let it happen, don't do anything
        return;
      } else {
        // Ensure that it is a number and stop the keypress
        if (
          event.shiftKey ||
          ((event.keyCode < 48 || event.keyCode > 57) &&
            (event.keyCode < 96 || event.keyCode > 105))
        ) {
          event.preventDefault();
        }
      }
    });
  }
};

ko.bindingHandlers.integer = {
  init: function(element) {
    $(element).on('keydown', function(event) {
      // Allow: backspace, delete, tab, escape, and enter
      if (
        event.keyCode == 46 ||
        event.keyCode == 8 ||
        event.keyCode == 9 ||
        event.keyCode == 27 ||
        event.keyCode == 13 ||
        // Allow: Ctrl+A
        (event.keyCode == 65 && event.ctrlKey === true) ||
        // Allow: home, end, left, right
        (event.keyCode >= 35 && event.keyCode <= 39)
      ) {
        // let it happen, don't do anything
        return;
      } else {
        // Ensure that it is a number and stop the keypress
        if (
          event.shiftKey ||
          ((event.keyCode < 48 || event.keyCode > 57) &&
            (event.keyCode < 96 || event.keyCode > 105))
        ) {
          event.preventDefault();
        }
      }
    });
  }
};

ko.bindingHandlers.decimal = {
  init: function(element) {
    $(element).on('keydown', function(event) {
      // Allow: backspace, delete, tab, escape, and enter
      if (
        event.keyCode == 46 ||
        event.keyCode == 8 ||
        event.keyCode == 9 ||
        event.keyCode == 27 ||
        event.keyCode == 13 ||
        // Allow: Ctrl+A
        (event.keyCode == 65 && event.ctrlKey === true) ||
        // Allow: home, end, left, right
        (event.keyCode >= 35 && event.keyCode <= 39)
      ) {
        // let it happen, don't do anything
        return;
      } else {
        // Ensure that it is a number and stop the keypress
        if (
          event.shiftKey ||
          ((event.keyCode < 48 || event.keyCode > 57) &&
            (event.keyCode < 96 || event.keyCode > 105) &&
            (event.keyCode < 188 || event.keyCode > 188))
        ) {
          event.preventDefault();
        }
      }
    });
  }
};

ko.bindingHandlers.datepicker = {
  format: 'dd.mm.yy',
  startDate: '+1d',
  init: function(element, valueAccessor, allBindingsAccessor) {
    var datepickerSettings = {
      format:
        allBindingsAccessor().format || ko.bindingHandlers.datepicker.format,
      startDate: allBindingsAccessor().oldDates ? new Date(2009, 0, 1) : '+1d',
      autoclose: true,
      clearBtn: true,
      language: 'nb',
      todayHighlight: true,
      weekStart: 1
    };

    if (allBindingsAccessor().noFutureDates) {
      $.extend(datepickerSettings, { endDate: '0d' });
    }

    var picker = $(element).datepicker(datepickerSettings);

    picker.on('changeDate', function(ev) {
      var val = valueAccessor();
      if (ko.isObservable(val)) {
        val(ev.date);
      } else {
        val = ev.date;
      }
    });
  },
  update: function(element, valueAccessor) {
    var val = ko.unwrap(valueAccessor());
    if (val !== undefined && val.length <= 0) return;
    if (val !== undefined && isNaN(val.getTime())) return;
    $(element).datepicker('update', val);
  }
};

//Drag and drop
var _dragged;
ko.bindingHandlers.drag = {
  init: function(element, valueAccessor) {
    var dragElement = $(element);
    var dragOptions = {
      helper: 'clone',
      revert: true,
      revertDuration: 0,
      start: function() {
        _dragged = ko.utils.unwrapObservable(valueAccessor().value);
      },
      cursor: 'default'
    };
    dragElement.draggable(dragOptions).disableSelection();
  }
};

ko.bindingHandlers.drop = {
  init: function(element, valueAccessor) {
    var dropElement = $(element);
    var dropOptions = {
      drop: function() {
        valueAccessor().value(_dragged);
      }
    };
    dropElement.droppable(dropOptions);
  }
};
